import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { CARRIER_NETWORK } from './actions';

export const reducers = createReducer(
	initialState,
	on(CARRIER_NETWORK.ACCOUNTS_LIST.GET, (state, action: any) => ({
		...state,
		loading: true,
	})),
	on(CARRIER_NETWORK.ACCOUNTS_LIST.FAILURE, (state, action: any) => ({
		...state,
		loading: false,
		error: action.payload.message,
	})),
	on(CARRIER_NETWORK.ACCOUNTS_LIST.SUCCESS, (state, action: any) => ({
		...state,
		loading: false,
		accountsList: action.data,
		total: action.numberOfResults,
	})),
	// set data
	on(CARRIER_NETWORK.SET.FILTER_LIST, (state, action: { filtersList: any[] }) => ({
		...state,
		filters: action.filtersList,
	})),
	on(CARRIER_NETWORK.SET.SORT_LIST, (state, action: { sortList: any[] }) => ({
		...state,
		sort: action.sortList,
	})),
	on(CARRIER_NETWORK.SET.PAGE, (state, { currentPage }) => ({
		...state,
		currentPage,
	})),
	on(CARRIER_NETWORK.SET.PAGE_SIZE, (state, { pageSize }) => ({
		...state,
		pageSize,
	})),

	// reset state
	on(CARRIER_NETWORK.RESET_STATE, (state) => ({
		...initialState,
	}))
);
